import { Tag } from 'antd';
import cs from 'classnames';
import { FC } from 'react';

import { FALLBACK_VALUE } from 'constants/uiSettings';

import { useTranslation } from 'react-i18next';
import styles from './StatusLongTag.module.scss';

interface StatusLongTagProps {
  status: boolean | null | undefined;
  invertColor?: boolean;
}

const StatusLongTag: FC<StatusLongTagProps> = ({ status, invertColor }) => {
  const { t } = useTranslation()

  if (status === null || status === undefined) {
    return FALLBACK_VALUE;
  }

  const iconClass = cs(styles.tagContainer, {
    [styles.green]: (status && !invertColor) || (!status && invertColor),
    [styles.red]: (!status && !invertColor) || (status && invertColor)
  });

  return (
    <Tag bordered={false} className={iconClass}>
      {status ? t('common.label.yes') : t('common.label.no')}
    </Tag>
  );
};

export default StatusLongTag;
